import React, { useState, useEffect } from "react";
import { useLocation, useRouteMatch } from "react-router-dom";
import clsx from "clsx";
import { Grid, AppBar } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import GlobalHeader from "../../../core/components/GlobalHeader/GlobalHeader";
import styles from "./styles";
import NavBar from "../../../core/components/NavBar/NavBar";
import authService from "../../../utils/authService";
import useAxios from "../../../core/hooks/useAxios";
import axios from "../../../utils/axiosUtil";
import { transactionRoutes } from "../../../routes/routeMap";
import Loader from "../Loader/Loader";
import ServerErrorPage from "../Error/ServerErrorPage";
import PageTitle from "../PageTitle/PageTitle";
import useSettings from "../../../core/hooks/useCommonSettings";
import { AppSnackbar } from "../Snackbar/AppSnackbar";

const Layout = React.memo((props) => {
  const [isLoading, isServerError] = useAxios(axios);
  const { children, menu, portalList, portalType } = props;
  const classes = makeStyles(styles)();

  const location = useLocation();
  const { getPageTitle, getShowAppBar } = useSettings();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [, setHeaderHeight] = useState(0);
  const toggleDrawer = (value) => {
    setDrawerOpen(value);
  };

  const pageTitleText = getPageTitle();
  const showAppBar = getShowAppBar();
  useEffect(() => {
    const header = document.getElementById("app-header");
    if (header) {
      setHeaderHeight(header.clientHeight);
    }
  }, [menu, location]);

  const match = useRouteMatch(transactionRoutes, {
    strict: true,
    sensitive: true,
  });
  const transactionRoute = match && match.isExact ? true : false;

  const containerStyle = {
    // backgroundColor: "#f5f7fb",
    // paddingTop: `${headerHeight + extraPadding}px`,
    position: "relative",
    flex: "1 1 auto",
    width: "100%",
    backgroundColor: "#ffffff",
    // paddingTop: "32px",
  };

  const rootStyles = {
    display: "flex",
    flexFlow: "column",
    height: "100%",
  };

  return (
    <div style={rootStyles}>
      <Loader showLoader={isLoading} />
      <AppSnackbar />
      {showAppBar && (
        <AppBar
          position="fixed"
          color="inherit"
          style={{
            flex: "0 1 auto",
            position: "sticky",
          }}
          className={clsx(classes.appBar, {
            [classes.appBarShift]: drawerOpen,
          })}
          id="app-header"
        >
          <Grid container className={classes.appBarWrapper}>
            <GlobalHeader toggleDrawer={toggleDrawer} portalList={portalList} portalType={portalType} />
            {authService.isAuthenticated() && !transactionRoute ? <NavBar menu={menu} /> : null}
          </Grid>
        </AppBar>
      )}

      <main style={containerStyle} id="layoutMainContainer">
        {isServerError ? (
          <ServerErrorPage />
        ) : (
          <>
            <PageTitle title={pageTitleText} />
            {children}
          </>
        )}
      </main>
    </div>
  );
});

export default Layout;
